// Viewport-class detection for the per-page mobile gate. Width-based, not
// user-agent sniffing: a tablet in landscape is a full workstation, a
// desktop window dragged narrow gets the phone treatment and gets it back
// when widened. Below Tailwind's `md` breakpoint counts as mobile.
import { useSyncExternalStore } from 'react';

const QUERY = '(max-width: 767px)';

function subscribe(onChange: () => void): () => void {
  if (typeof window === 'undefined' || !window.matchMedia) return () => {};
  const mq = window.matchMedia(QUERY);
  mq.addEventListener('change', onChange);
  return () => mq.removeEventListener('change', onChange);
}

function snapshot(): boolean {
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  return window.matchMedia(QUERY).matches;
}

export function useIsMobile(): boolean {
  return useSyncExternalStore(subscribe, snapshot);
}
